<template>
  <div>
    <div class="left-container">
      <noticeboard-list @selected="selected" />
    </div>
    <div class="right-container">
      <noticeboard-detail-card :source-id="noticeboardId" />
    </div>
  </div>
</template>

<script>
import NoticeboardDetailCard from '@/pages/data/components/NoticeboardDetailCard';
import NoticeboardList from '@/pages/data/components/NoticeboardList';
export default {
  components: { NoticeboardDetailCard, NoticeboardList },
  data() {
    return {
      noticeboardId: parseInt(this.$route.query.noticeboardId) || null
    };
  },
  watch: {
    $route() {
      this.noticeboardId = parseInt(this.$route.query.noticeboardId) || null;
    }
  },
  methods: {
    selected(value) {
      this.$router.push({
        name: 'pages:data:noticeboard:notice',
        query: {
          noticeboardId: value
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.left-container {
  width: 200px;
  float: left;
  margin-right: 16px;
}
.right-container {
  width: calc(~'100% - 216px');
  float: left;
}
</style>
